import { Table, Column, Cell } from "fixed-data-table-2";
import moment from "moment";
import PropTypes from "prop-types";
import {
  LinearProgress,
  CircularProgress,
  Typography
} from "@material-ui/core";
import React from "react";
import RowActionMenuPopover from "./RowActionMenuPopover";

class FormStatusTable extends React.Component {
  constructor(props) {
    super(props);
    this.onColumnResizeEndCallback = this.onColumnResizeEndCallback.bind(this);

    this.state = {
      columnWidths: {
        start_dt: 125,
        hakai_id: 100,
        processing_stage: 125,
        device_sn: 50,
        filename: 260,
        status: 135,
        actions: 55,
        index: 50
      }
    };
  }

  onColumnResizeEndCallback(newColumnWidth, columnKey) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth
      }
    }));
  }

  render() {
    const styles = {
      statusBadge: {
        fontSize: "12px",
        display: "inline-block",
        fontWeight: "bold",
        color: "white",
        padding: "5px",
        minWidth: "20px",
        borderRadius: "10px",
        verticalAlign: "top",
        marginRight: "3px",
        marginTop: "8px"
      },
      tableFont: {
        fontFamily: "Roboto",
        fontSize: "14px"
      }
    };

    const { columnWidths } = this.state;
    if (this.props.isFetching)
      return <LinearProgress style={{ width: "100%" }} />;
    if (!this.props.formDataFiltered.length)
      return (
        <Typography>
          <b>No Submission Data found</b>
        </Typography>
      );

    const rows = this.props.formDataFiltered;

    return (
      <div>
        <Typography>
          {this.props.formData.length && (
            <span>
              <b>{this.props.formDataFiltered.length}</b> records found.
            </span>
          )}
          {this.props.formData.length !==
            this.props.formDataFiltered.length && (
            <span>
              {" "}
              Filtering on rows containing {`"${this.props.searchFilter}"`}
            </span>
          )}
        </Typography>
        <div style={styles.tableFont}>
          <Table
            rowHeight={75}
            rowsCount={rows.length}
            width={this.props.width}
            headerHeight={50}
            height={window.innerHeight - 100}
            onColumnResizeEndCallback={this.onColumnResizeEndCallback}
            isColumnResizing={false}
          >
            <Column
              columnKey="status"
              header={<Cell> Status </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>
                  {this.props.rowsUpdating &&
                    this.props.rowsUpdating.includes(
                      rows[rowIndex].hakai_id
                    ) && (
                      <CircularProgress
                        size={35}
                        thickness={5}
                        style={{ marginRight: "3px" }}
                      />
                    )}
                  {!rows[rowIndex].process_error && (
                    <span
                      style={{
                        ...styles.statusBadge,
                        backgroundColor: "#53c77c"
                      }}
                    >
                      OK
                    </span>
                  )}
                  {rows[rowIndex].process_error && (
                    <span
                      style={{
                        ...styles.statusBadge,

                        backgroundColor: "rgb(182, 12, 15)"
                      }}
                    >
                      Error
                    </span>
                  )}
                </Cell>
              )}
              width={columnWidths.status}
              isResizable
            />

            <Column
              columnKey="start"
              header={<Cell> Start </Cell>}
              cell={({ ...colProps }) => (
                <Cell {...colProps}>
                  {moment(rows[colProps.rowIndex].start_dt).format(
                    "YYYY-MM-DD H:mm"
                  )}
                </Cell>
              )}
              width={columnWidths.start_dt}
              isResizable
              // flexGrow={1}
            />

            <Column
              columnKey="hakai_id"
              header={<Cell> Hakai ID </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].hakai_id}</Cell>
              )}
              width={columnWidths.hakai_id}
              isResizable
              flexGrow={1}
            />

            <Column
              columnKey="processing_stage"
              header={<Cell> Stage </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].processing_stage}</Cell>
              )}
              width={columnWidths.processing_stage}
              isResizable
            />

            <Column
              columnKey="device_sn"
              header={<Cell> Device </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].device_sn}</Cell>
              )}
              width={columnWidths.device_sn}
              isResizable
              flexGrow={1}
            />

            <Column
              columnKey="filename"
              header={<Cell> Filename </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].filename}</Cell>
              )}
              width={columnWidths.filename}
              isResizable
              flexGrow={1}
            />
            <Column
              columnKey="actions"
              header={<Cell />}
              cell={({ rowIndex }) => (
                <Cell style={{ marginTop: "5px" }}>
                  <RowActionMenuPopover {...this.props} rowIndex={rowIndex} />
                </Cell>
              )}
              width={columnWidths.actions}
            />
          </Table>
        </div>
      </div>
    );
  }
}

FormStatusTable.propTypes = {
  rowsUpdating: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchFilter: PropTypes.string.isRequired,
  showWirewalker: PropTypes.bool.isRequired,
  onStatusRowClick: PropTypes.func.isRequired,
  width: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  formData: PropTypes.arrayOf(PropTypes.object),
  formDataFiltered: PropTypes.arrayOf(
    PropTypes.shape({
      device_sn: PropTypes.string,
      process_error: PropTypes.string,
      processing_stage: PropTypes.string,
      hakai_id: PropTypes.string,
      start_dt: PropTypes.string,
      filename: PropTypes.string
    })
  ).isRequired,
  isFetching: PropTypes.bool
};

FormStatusTable.defaultProps = {
  formData: [],
  isFetching: false,
  width: 0
};

FormStatusTable.shouldComponentUpdate = () => false;
export default FormStatusTable;
